import { useCallback, useLayoutEffect, useRef, useState } from "react";

// Sprint DASHBOARD-FIX-2 — celle e larghezze condivise dalle liste Veicoli/WEB e Preventivi/Pratiche.
export const LARG_MIN = 72;
export const LARG_MAX = 280;

// Sprint LISTE-2 — regola unica per le liste: si applica solo la risposta dell'ULTIMA richiesta.
// Senza, due richieste in volo (es. ordinamento predefinito e ordinamento salvato) arrivano in ordine
// casuale e la più vecchia sovrascrive la più nuova: l'ordine sembra «invertirsi» al rientro.
export function useUltimaRichiesta() {
  const n = useRef(0);
  return useCallback(() => {
    const id = ++n.current;
    return () => id === n.current;
  }, []);
}

// Sprint LISTE-2 — campi di ricerca: niente suggerimenti di compilazione del browser.
export const attrRicerca = (nome) => ({
  name: `kg-ricerca-${nome}`, autoComplete: "off", autoCorrect: "off", autoCapitalize: "off",
  spellCheck: false, "data-lpignore": "true", "data-1p-ignore": "true", "data-form-type": "other",
});

// Data mostrata GG/MM/AAAA; il valore tecnico (ordinamento, filtri, indirizzi) resta ISO.
export const fmtData = (d) => {
  if (!d) return "—";
  const s = String(d).slice(0, 10);
  const [y, m, g] = s.split("-");
  if (!y || !m || !g) return s;
  return `${g}/${m}/${y}`;
};

const titoloSeTroncato = (e) => {
  const el = e.currentTarget;
  if (el.scrollWidth > el.clientWidth) el.title = el.textContent;
  else el.removeAttribute("title");
};

// Contenuto di cella: una riga per informazione, senza andare a capo; oltre il massimo i puntini.
export function Cella({ children, servizio = false }) {
  return <div className={`cella${servizio ? " cella-servizio" : ""}`} onMouseEnter={titoloSeTroncato}>{children}</div>;
}

// Larghezza adattata al contenuto (intestazione + righe visibili) per ogni colonna marcata data-col.
export function useLarghezzeAuto(tableRef, deps) {
  const [auto, setAuto] = useState({});
  useLayoutEffect(() => {
    const t = tableRef.current;
    if (!t) return;
    const nat = {};
    t.querySelectorAll("[data-col]").forEach((cell) => {
      const k = cell.getAttribute("data-col");
      const inner = cell.querySelector(".cella, .th-label");
      if (!inner) return;
      const cs = getComputedStyle(cell);
      const extra = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) + (cell.tagName === "TH" ? 22 : 2);
      // le righe interne (div) tagliano da sé: la larghezza naturale è la più larga fra cella e righe
      const w = Math.max(inner.scrollWidth, ...[...inner.children].map((c) => c.scrollWidth));
      nat[k] = Math.max(nat[k] || 0, Math.ceil(w + extra));
    });
    const next = Object.fromEntries(Object.entries(nat).map(([k, w]) => [k, Math.min(LARG_MAX, Math.max(LARG_MIN, w))]));
    setAuto((prev) => (JSON.stringify(prev) === JSON.stringify(next) ? prev : next));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return auto;
}
